// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// const CreateStorybyReporter = () => {
//   const navigate = useNavigate();

//   const styles = {
//     container: {
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       height: '85vh',
//       textAlign: 'center',
//       fontFamily: '"Inter", "Segoe UI", sans-serif',
//       backgroundColor: '#ffffff',
//       padding: '20px'
//     },
//     card: {
//       maxWidth: '650px',
//       padding: '40px',
//       borderRadius: '25px',
//       boxShadow: '0 20px 40px rgba(0,0,0,0.06)',
//       border: '1px solid #f0f0f0',
//       position: 'relative'
//     },
//     // Instagram Story Ring Effect
//     storyRing: {
//       width: '100px',
//       height: '100px',
//       borderRadius: '50%',
//       padding: '4px',
//       background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
//       display: 'inline-block',
//       marginBottom: '20px',
//       animation: 'pulse 2s infinite'
//     },
//     innerCircle: {
//       width: '100%',
//       height: '100%',
//       borderRadius: '50%',
//       backgroundColor: '#fff',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       fontSize: '45px'
//     },
//     badge: {
//       background: 'linear-gradient(45deg, #f09433, #bc1888)',
//       color: '#fff',
//       padding: '6px 20px',
//       borderRadius: '50px',
//       fontSize: '0.8rem',
//       fontWeight: 'bold',
//       letterSpacing: '1.2px',
//       marginBottom: '20px',
//       display: 'inline-block'
//     },
//     heading: {
//       fontSize: '2.4rem',
//       fontWeight: '800',
//       color: '#1a202c',
//       marginBottom: '15px'
//     },
//     subHeading: {
//       fontSize: '1.1rem',
//       color: '#4a5568',
//       lineHeight: '1.7',
//       marginBottom: '30px'
//     },
//     progressBar: {
//       width: '100%',
//       height: '8px',
//       backgroundColor: '#edf2f7',
//       borderRadius: '10px',
//       overflow: 'hidden',
//       marginBottom: '10px'
//     },
//     progressFill: {
//       width: '40%', // 40% Progress
//       height: '100%',
//       background: 'linear-gradient(90deg, #f09433, #bc1888)',
//       borderRadius: '10px',
//       animation: 'loading 2.5s infinite ease-in-out'
//     },
//     statusText: {
//       fontSize: '0.85rem',
//       color: '#a0aec0',
//       fontWeight: '600'
//     },
//     button: {
//       marginTop: '35px',
//       padding: '12px 30px',
//       fontSize: '1rem',
//       fontWeight: '600',
//       backgroundColor: '#1a202c',
//       color: 'white',
//       border: 'none',
//       borderRadius: '8px',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease'
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <style>
//         {`
//           @keyframes pulse {
//             0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(220, 39, 67, 0.4); }
//             50% { transform: scale(1.05); box-shadow: 0 0 20px 10px rgba(220, 39, 67, 0); }
//             100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(220, 39, 67, 0); }
//           }
//           @keyframes loading {
//             0% { transform: translateX(-100%); }
//             100% { transform: translateX(200%); }
//           }
//         `}
//       </style>

//       <div style={styles.card}>
//         {/* Instagram style Story Ring */}
//         <div style={styles.storyRing}>
//           <div style={styles.innerCircle}>📸</div>
//         </div>
        
//         <br />
//         <div style={styles.badge}>COMING SOON</div>
        
//         <h1 style={styles.heading}>Instant Stories</h1>
        
       
        
//         <div style={styles.progressBar}>
//           <div style={styles.progressFill}></div>
//         </div>
//         <div style={styles.statusText}>Development Status: 40% Completed (UI Design Phase)</div>

//         <button 
//           style={styles.button} 
//           onClick={() => navigate(-1)}
//           onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
//           onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
//         >
//           Return to Dashboard
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CreateStorybyReporter;


// // import { useState, useEffect, useCallback } from "react";
// // import {
// //   createStoryByReporter,
// //   getMyStories,
// //   updateStoryByReporter,
// //   deleteStoryByReporter,
// // } from "../../../services/reporterService"; // apna actual path adjust karein

// // // ---- Status badge ----
// // const STATUS_STYLES = {
// //   posted: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
// //   pending_approval: "bg-amber-50 text-amber-700 ring-amber-600/20",
// //   rejected: "bg-rose-50 text-rose-700 ring-rose-600/20",
// // };
// // const STATUS_LABEL = {
// //   posted: "Posted",
// //   pending_approval: "Waiting for approval",
// //   rejected: "Rejected",
// // };

// // function StatusBadge({ status }) {
// //   return (
// //     <span
// //       className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset ${
// //         STATUS_STYLES[status] || "bg-slate-100 text-slate-600 ring-slate-500/20"
// //       }`}
// //     >
// //       {STATUS_LABEL[status] || status}
// //     </span>
// //   );
// // }

// // export default function ReporterStoryPage() {
// //   const [stories, setStories] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [showForm, setShowForm] = useState(false);
// //   const [submitting, setSubmitting] = useState(false);

// //   // form state
// //   const [title, setTitle] = useState("");
// //   const [summary, setSummary] = useState("");
// //   const [category, setCategory] = useState("");
// //   const [tags, setTags] = useState("");
// //   const [files, setFiles] = useState([]);
// //   const [captions, setCaptions] = useState([]);
// //   const [externalUrl, setExternalUrl] = useState("");
// //   const [externalCaption, setExternalCaption] = useState("");
// //   const [externalSlides, setExternalSlides] = useState([]);
// //   const [formError, setFormError] = useState("");

// //   const loadStories = useCallback(async () => {
// //     setLoading(true);
// //     setError("");
// //     try {
// //       const res = await getMyStories();
// //       setStories(res.data || []);
// //     } catch (err) {
// //       setError(err.response?.data?.message || "Stories load nahi ho sakin.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, []);

// //   useEffect(() => {
// //     loadStories();
// //   }, [loadStories]);

// //   const resetForm = () => {
// //     setTitle("");
// //     setSummary("");
// //     setCategory("");
// //     setTags("");
// //     setFiles([]);
// //     setCaptions([]);
// //     setExternalUrl("");
// //     setExternalCaption("");
// //     setExternalSlides([]);
// //     setFormError("");
// //   };

// //   const handleFileChange = (e) => {
// //     const chosen = Array.from(e.target.files || []);
// //     setFiles(chosen);
// //     setCaptions(chosen.map(() => ""));
// //   };

// //   const addExternalSlide = () => {
// //     if (!externalUrl.trim()) return;
// //     setExternalSlides((prev) => [...prev, { mediaUrl: externalUrl.trim(), caption: externalCaption.trim() }]);
// //     setExternalUrl("");
// //     setExternalCaption("");
// //   };

// //   const removeExternalSlide = (idx) => {
// //     setExternalSlides((prev) => prev.filter((_, i) => i !== idx));
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setFormError("");

// //     if (!title.trim() || !category.trim()) {
// //       setFormError("Title aur category dono zaroori hain.");
// //       return;
// //     }

// //     const formData = new FormData();
// //     formData.append("title", title.trim());
// //     formData.append("summary", summary.trim());
// //     formData.append("category", category.trim());
// //     formData.append(
// //       "tags",
// //       JSON.stringify(
// //         tags
// //           .split(",")
// //           .map((t) => t.trim())
// //           .filter(Boolean)
// //       )
// //     );
// //     formData.append("externalSlides", JSON.stringify(externalSlides));
// //     files.forEach((file) => formData.append("slides", file));
// //     captions.forEach((cap) => formData.append("captions", cap));

// //     setSubmitting(true);
// //     try {
// //       const res = await createStoryByReporter(formData);
// //       const status = res.data?.status;
// //       if (status === "pending_approval") {
// //         setError("");
// //         alert("Story submit ho gayi hai — admin approval ke baad hi live hogi.");
// //       } else {
// //         alert("Story publish ho gayi.");
// //       }
// //       resetForm();
// //       setShowForm(false);
// //       loadStories();
// //     } catch (err) {
// //       setFormError(err.response?.data?.message || "Story create nahi ho payi.");
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };

// //   const handleDelete = async (storyId) => {
// //     if (!window.confirm("Ye story permanently delete kar dein?")) return;
// //     try {
// //       await deleteStoryByReporter(storyId);
// //       setStories((prev) => prev.filter((s) => s._id !== storyId));
// //     } catch (err) {
// //       alert(err.response?.data?.message || "Delete nahi ho paya.");
// //     }
// //   };

// //   const handleResubmit = async (story) => {
// //     if (!window.confirm("Ye story dobara approval ke liye bhej dein?")) return;
// //     try {
// //       await updateStoryByReporter(story._id, { status: "pending_approval" });
// //       loadStories();
// //     } catch (err) {
// //       alert(err.response?.data?.message || "Resubmit nahi ho paya.");
// //     }
// //   };

// //   return (
// //     <div className="min-h-screen bg-[#F6F4EF]">
// //       <header className="border-b border-[#E2DDD1] bg-white">
// //         <div className="mx-auto max-w-5xl px-6 py-6 flex items-center justify-between">
// //           <div>
// //             <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#B4501F]">Reporter Desk</p>
// //             <h1 className="mt-1 font-serif text-2xl text-[#1E2430]">Meri Stories</h1>
// //           </div>
// //           <button
// //             onClick={() => setShowForm((v) => !v)}
// //             className="rounded-md bg-[#1E2430] px-4 py-2 text-sm font-medium text-white hover:bg-[#2A3140] transition"
// //           >
// //             {showForm ? "Band karein" : "+ Nayi Story"}
// //           </button>
// //         </div>
// //       </header>

// //       <main className="mx-auto max-w-5xl px-6 py-8 space-y-8">
// //         {showForm && (
// //           <form
// //             onSubmit={handleSubmit}
// //             className="rounded-lg border border-[#E2DDD1] bg-white p-6 space-y-5"
// //           >
// //             <p className="text-sm text-[#6B6357]">
// //               Note: agar aapke paas direct-post ki permission nahi hai, ye story admin approval ke liye jayegi.
// //             </p>

// //             {formError && (
// //               <div className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700 ring-1 ring-rose-600/20">
// //                 {formError}
// //               </div>
// //             )}

// //             <div>
// //               <label className="block text-sm font-medium text-[#1E2430] mb-1">Title *</label>
// //               <input
// //                 type="text"
// //                 value={title}
// //                 onChange={(e) => setTitle(e.target.value)}
// //                 className="w-full rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
// //                 placeholder="Story ka title likhein"
// //               />
// //             </div>

// //             <div>
// //               <label className="block text-sm font-medium text-[#1E2430] mb-1">Summary</label>
// //               <textarea
// //                 value={summary}
// //                 onChange={(e) => setSummary(e.target.value)}
// //                 rows={3}
// //                 className="w-full rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
// //                 placeholder="Chhota summary (optional)"
// //               />
// //             </div>

// //             <div className="grid grid-cols-2 gap-4">
// //               <div>
// //                 <label className="block text-sm font-medium text-[#1E2430] mb-1">Category *</label>
// //                 <input
// //                   type="text"
// //                   value={category}
// //                   onChange={(e) => setCategory(e.target.value)}
// //                   className="w-full rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
// //                   placeholder="Category ID ya naam"
// //                 />
// //               </div>
// //               <div>
// //                 <label className="block text-sm font-medium text-[#1E2430] mb-1">Tags (comma se separate)</label>
// //                 <input
// //                   type="text"
// //                   value={tags}
// //                   onChange={(e) => setTags(e.target.value)}
// //                   className="w-full rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
// //                   placeholder="politics, local, breaking"
// //                 />
// //               </div>
// //             </div>

// //             <div>
// //               <label className="block text-sm font-medium text-[#1E2430] mb-1">Slides (image/video)</label>
// //               <input
// //                 type="file"
// //                 multiple
// //                 accept="image/*,video/*"
// //                 onChange={handleFileChange}
// //                 className="block w-full text-sm text-[#6B6357]"
// //               />
// //               {files.length > 0 && (
// //                 <div className="mt-3 space-y-2">
// //                   {files.map((file, idx) => (
// //                     <div key={idx} className="flex items-center gap-2">
// //                       <span className="text-xs text-[#6B6357] w-40 truncate">{file.name}</span>
// //                       <input
// //                         type="text"
// //                         placeholder="Caption (optional)"
// //                         value={captions[idx] || ""}
// //                         onChange={(e) => {
// //                           const next = [...captions];
// //                           next[idx] = e.target.value;
// //                           setCaptions(next);
// //                         }}
// //                         className="flex-1 rounded-md border border-[#D8D2C4] px-2 py-1 text-xs"
// //                       />
// //                     </div>
// //                   ))}
// //                 </div>
// //               )}
// //             </div>

// //             <div>
// //               <label className="block text-sm font-medium text-[#1E2430] mb-1">External slide link (optional)</label>
// //               <div className="flex gap-2">
// //                 <input
// //                   type="text"
// //                   value={externalUrl}
// //                   onChange={(e) => setExternalUrl(e.target.value)}
// //                   placeholder="https://..."
// //                   className="flex-1 rounded-md border border-[#D8D2C4] px-3 py-2 text-sm"
// //                 />
// //                 <input
// //                   type="text"
// //                   value={externalCaption}
// //                   onChange={(e) => setExternalCaption(e.target.value)}
// //                   placeholder="Caption"
// //                   className="w-40 rounded-md border border-[#D8D2C4] px-3 py-2 text-sm"
// //                 />
// //                 <button
// //                   type="button"
// //                   onClick={addExternalSlide}
// //                   className="rounded-md border border-[#1E2430] px-3 py-2 text-sm hover:bg-[#1E2430] hover:text-white transition"
// //                 >
// //                   Add
// //                 </button>
// //               </div>
// //               {externalSlides.length > 0 && (
// //                 <ul className="mt-2 space-y-1">
// //                   {externalSlides.map((s, idx) => (
// //                     <li key={idx} className="flex items-center justify-between text-xs text-[#6B6357] bg-[#F6F4EF] rounded px-2 py-1">
// //                       <span className="truncate">{s.mediaUrl} — {s.caption}</span>
// //                       <button type="button" onClick={() => removeExternalSlide(idx)} className="text-rose-600 ml-2">
// //                         Remove
// //                       </button>
// //                     </li>
// //                   ))}
// //                 </ul>
// //               )}
// //             </div>

// //             <div className="flex justify-end gap-2 pt-2">
// //               <button
// //                 type="button"
// //                 onClick={() => {
// //                   resetForm();
// //                   setShowForm(false);
// //                 }}
// //                 className="rounded-md px-4 py-2 text-sm text-[#6B6357] hover:bg-[#F6F4EF]"
// //               >
// //                 Cancel
// //               </button>
// //               <button
// //                 type="submit"
// //                 disabled={submitting}
// //                 className="rounded-md bg-[#B4501F] px-4 py-2 text-sm font-medium text-white hover:bg-[#963F16] transition disabled:opacity-50"
// //               >
// //                 {submitting ? "Submit ho rahi hai..." : "Story submit karein"}
// //               </button>
// //             </div>
// //           </form>
// //         )}

// //         {error && (
// //           <div className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700 ring-1 ring-rose-600/20">{error}</div>
// //         )}

// //         {loading ? (
// //           <p className="text-sm text-[#6B6357]">Load ho raha hai...</p>
// //         ) : stories.length === 0 ? (
// //           <div className="rounded-lg border border-dashed border-[#D8D2C4] bg-white p-10 text-center text-sm text-[#6B6357]">
// //             Abhi tak koi story nahi banayi. "+ Nayi Story" par click karein.
// //           </div>
// //         ) : (
// //           <div className="overflow-hidden rounded-lg border border-[#E2DDD1] bg-white">
// //             <table className="w-full text-left text-sm">
// //               <thead className="bg-[#F6F4EF] text-xs uppercase tracking-wide text-[#6B6357]">
// //                 <tr>
// //                   <th className="px-4 py-3">Title</th>
// //                   <th className="px-4 py-3">Status</th>
// //                   <th className="px-4 py-3">Banayi gayi</th>
// //                   <th className="px-4 py-3 text-right">Actions</th>
// //                 </tr>
// //               </thead>
// //               <tbody className="divide-y divide-[#EDE8DC]">
// //                 {stories.map((story) => (
// //                   <tr key={story._id}>
// //                     <td className="px-4 py-3">
// //                       <p className="font-medium text-[#1E2430]">{story.title}</p>
// //                       {story.status === "rejected" && story.rejectionReason && (
// //                         <p className="mt-1 text-xs text-rose-600">Reason: {story.rejectionReason}</p>
// //                       )}
// //                     </td>
// //                     <td className="px-4 py-3">
// //                       <StatusBadge status={story.status} />
// //                     </td>
// //                     <td className="px-4 py-3 text-[#6B6357]">
// //                       {new Date(story.createdAt).toLocaleDateString("en-IN")}
// //                     </td>
// //                     <td className="px-4 py-3 text-right space-x-3">
// //                       {story.status === "rejected" && (
// //                         <button
// //                           onClick={() => handleResubmit(story)}
// //                           className="text-xs font-medium text-[#B4501F] hover:underline"
// //                         >
// //                           Resubmit
// //                         </button>
// //                       )}
// //                       <button
// //                         onClick={() => handleDelete(story._id)}
// //                         className="text-xs font-medium text-rose-600 hover:underline"
// //                       >
// //                         Delete
// //                       </button>
// //                     </td>
// //                   </tr>
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         )}
// //       </main>
// //     </div>
// //   );
// // }


// import { useState, useEffect, useCallback } from "react";
// import {
//   createStoryByReporter,
//   getMyStories,
//   updateStoryByReporter,
//   deleteStoryByReporter,
//   getAllCategories,
// } from "../../../services/reporterService"; // apna actual path adjust karein

// // ---- Status badge ----
// const STATUS_STYLES = {
//   posted: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
//   pending_approval: "bg-amber-50 text-amber-700 ring-amber-600/20",
//   rejected: "bg-rose-50 text-rose-700 ring-rose-600/20",
// };
// const STATUS_LABEL = {
//   posted: "Posted",
//   pending_approval: "Waiting for approval",
//   rejected: "Rejected",
// };

// function StatusBadge({ status }) {
//   return (
//     <span
//       className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset ${
//         STATUS_STYLES[status] || "bg-slate-100 text-slate-600 ring-slate-500/20"
//       }`}
//     >
//       {STATUS_LABEL[status] || status}
//     </span>
//   );
// }

// export default function ReporterStoryPage() {
//   const [stories, setStories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [submitting, setSubmitting] = useState(false);

//   // form state
//   const [title, setTitle] = useState("");
//   const [summary, setSummary] = useState("");
//   const [category, setCategory] = useState("");
//   const [categories, setCategories] = useState([]);
//   const [tags, setTags] = useState("");
//   const [files, setFiles] = useState([]);
//   const [captions, setCaptions] = useState([]);
//   const [externalUrl, setExternalUrl] = useState("");
//   const [externalCaption, setExternalCaption] = useState("");
//   const [externalSlides, setExternalSlides] = useState([]);
//   const [formError, setFormError] = useState("");

//   const loadStories = useCallback(async () => {
//     setLoading(true);
//     setError("");
//     try {
//       const res = await getMyStories();
//       setStories(res.data || []);
//     } catch (err) {
//       setError(err.response?.data?.message || "Stories load nahi ho sakin.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     loadStories();
//   }, [loadStories]);

//   useEffect(() => {
//     (async () => {
//       try {
//         const res = await getAllCategories();
//         setCategories(res?.data || []);
//       } catch (err) {
//         console.error("Error fetching categories:", err);
//       }
//     })();
//   }, []);

//   const resetForm = () => {
//     setTitle("");
//     setSummary("");
//     setCategory("");
//     setTags("");
//     setFiles([]);
//     setCaptions([]);
//     setExternalUrl("");
//     setExternalCaption("");
//     setExternalSlides([]);
//     setFormError("");
//   };

//   const handleFileChange = (e) => {
//     const chosen = Array.from(e.target.files || []);
//     setFiles(chosen);
//     setCaptions(chosen.map(() => ""));
//   };

//   const addExternalSlide = () => {
//     if (!externalUrl.trim()) return;
//     setExternalSlides((prev) => [...prev, { mediaUrl: externalUrl.trim(), caption: externalCaption.trim() }]);
//     setExternalUrl("");
//     setExternalCaption("");
//   };

//   const removeExternalSlide = (idx) => {
//     setExternalSlides((prev) => prev.filter((_, i) => i !== idx));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setFormError("");

//     if (!title.trim() || !category.trim()) {
//       setFormError("Title aur category dono zaroori hain.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("title", title.trim());
//     formData.append("summary", summary.trim());
//     formData.append("category", category.trim());
//     formData.append(
//       "tags",
//       JSON.stringify(
//         tags
//           .split(",")
//           .map((t) => t.trim())
//           .filter(Boolean)
//       )
//     );
//     formData.append("externalSlides", JSON.stringify(externalSlides));
//     files.forEach((file) => formData.append("slides", file));
//     captions.forEach((cap) => formData.append("captions", cap));

//     setSubmitting(true);
//     try {
//       const res = await createStoryByReporter(formData);
//       const status = res.data?.status;
//       if (status === "pending_approval") {
//         setError("");
//         alert("Story submit ho gayi hai — admin approval ke baad hi live hogi.");
//       } else {
//         alert("Story publish ho gayi.");
//       }
//       resetForm();
//       setShowForm(false);
//       loadStories();
//     } catch (err) {
//       setFormError(err.response?.data?.message || "Story create nahi ho payi.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleDelete = async (storyId) => {
//     if (!window.confirm("Ye story permanently delete kar dein?")) return;
//     try {
//       await deleteStoryByReporter(storyId);
//       setStories((prev) => prev.filter((s) => s._id !== storyId));
//     } catch (err) {
//       alert(err.response?.data?.message || "Delete nahi ho paya.");
//     }
//   };

//   const handleResubmit = async (story) => {
//     if (!window.confirm("Ye story dobara approval ke liye bhej dein?")) return;
//     try {
//       await updateStoryByReporter(story._id, { status: "pending_approval" });
//       loadStories();
//     } catch (err) {
//       alert(err.response?.data?.message || "Resubmit nahi ho paya.");
//     }
//   };

//   return (
//     <div className="min-h-screen bg-[#F6F4EF]">
//       <header className="border-b border-[#E2DDD1] bg-white">
//         <div className="mx-auto max-w-5xl px-6 py-6 flex items-center justify-between">
//           <div>
//             <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#B4501F]">Reporter Desk</p>
//             <h1 className="mt-1 font-serif text-2xl text-[#1E2430]">Meri Stories</h1>
//           </div>
//           <button
//             onClick={() => setShowForm((v) => !v)}
//             className="rounded-md bg-[#1E2430] px-4 py-2 text-sm font-medium text-white hover:bg-[#2A3140] transition"
//           >
//             {showForm ? "Band karein" : "+ Nayi Story"}
//           </button>
//         </div>
//       </header>

//       <main className="mx-auto max-w-5xl px-6 py-8 space-y-8">
//         {showForm && (
//           <form
//             onSubmit={handleSubmit}
//             className="rounded-lg border border-[#E2DDD1] bg-white p-6 space-y-5"
//           >
//             <p className="text-sm text-[#6B6357]">
//               Note: agar aapke paas direct-post ki permission nahi hai, ye story admin approval ke liye jayegi.
//             </p>

//             {formError && (
//               <div className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700 ring-1 ring-rose-600/20">
//                 {formError}
//               </div>
//             )}

//             <div>
//               <label className="block text-sm font-medium text-[#1E2430] mb-1">Title *</label>
//               <input
//                 type="text"
//                 value={title}
//                 onChange={(e) => setTitle(e.target.value)}
//                 className="w-full rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
//                 placeholder="Story ka title likhein"
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-[#1E2430] mb-1">Summary</label>
//               <textarea
//                 value={summary}
//                 onChange={(e) => setSummary(e.target.value)}
//                 rows={3}
//                 className="w-full rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
//                 placeholder="Chhota summary (optional)"
//               />
//             </div>

//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-sm font-medium text-[#1E2430] mb-1">Category *</label>
//                 <select
//                   value={category}
//                   onChange={(e) => setCategory(e.target.value)}
//                   className="w-full rounded-md border border-[#D8D2C4] px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
//                 >
//                   <option value="">-- Category chunein --</option>
//                   {categories.map((cat) => (
//                     <option key={cat._id} value={cat._id}>
//                       {cat.name}
//                     </option>
//                   ))}
//                 </select>
//                 {categories.length === 0 && (
//                   <p className="mt-1 text-xs text-[#B4501F]">Categories load nahi hui — pehle category list check karein.</p>
//                 )}
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-[#1E2430] mb-1">Tags (comma se separate)</label>
//                 <input
//                   type="text"
//                   value={tags}
//                   onChange={(e) => setTags(e.target.value)}
//                   className="w-full rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
//                   placeholder="politics, local, breaking"
//                 />
//               </div>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-[#1E2430] mb-1">Slides (image/video)</label>
//               <input
//                 type="file"
//                 multiple
//                 accept="image/*,video/*"
//                 onChange={handleFileChange}
//                 className="block w-full text-sm text-[#6B6357]"
//               />
//               {files.length > 0 && (
//                 <div className="mt-3 space-y-2">
//                   {files.map((file, idx) => (
//                     <div key={idx} className="flex items-center gap-2">
//                       <span className="text-xs text-[#6B6357] w-40 truncate">{file.name}</span>
//                       <input
//                         type="text"
//                         placeholder="Caption (optional)"
//                         value={captions[idx] || ""}
//                         onChange={(e) => {
//                           const next = [...captions];
//                           next[idx] = e.target.value;
//                           setCaptions(next);
//                         }}
//                         className="flex-1 rounded-md border border-[#D8D2C4] px-2 py-1 text-xs"
//                       />
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-[#1E2430] mb-1">External slide link (optional)</label>
//               <div className="flex gap-2">
//                 <input
//                   type="text"
//                   value={externalUrl}
//                   onChange={(e) => setExternalUrl(e.target.value)}
//                   placeholder="https://..."
//                   className="flex-1 rounded-md border border-[#D8D2C4] px-3 py-2 text-sm"
//                 />
//                 <input
//                   type="text"
//                   value={externalCaption}
//                   onChange={(e) => setExternalCaption(e.target.value)}
//                   placeholder="Caption"
//                   className="w-40 rounded-md border border-[#D8D2C4] px-3 py-2 text-sm"
//                 />
//                 <button
//                   type="button"
//                   onClick={addExternalSlide}
//                   className="rounded-md border border-[#1E2430] px-3 py-2 text-sm hover:bg-[#1E2430] hover:text-white transition"
//                 >
//                   Add
//                 </button>
//               </div>
//               {externalSlides.length > 0 && (
//                 <ul className="mt-2 space-y-1">
//                   {externalSlides.map((s, idx) => (
//                     <li key={idx} className="flex items-center justify-between text-xs text-[#6B6357] bg-[#F6F4EF] rounded px-2 py-1">
//                       <span className="truncate">{s.mediaUrl} — {s.caption}</span>
//                       <button type="button" onClick={() => removeExternalSlide(idx)} className="text-rose-600 ml-2">
//                         Remove
//                       </button>
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>

//             <div className="flex justify-end gap-2 pt-2">
//               <button
//                 type="button"
//                 onClick={() => {
//                   resetForm();
//                   setShowForm(false);
//                 }}
//                 className="rounded-md px-4 py-2 text-sm text-[#6B6357] hover:bg-[#F6F4EF]"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 disabled={submitting}
//                 className="rounded-md bg-[#B4501F] px-4 py-2 text-sm font-medium text-white hover:bg-[#963F16] transition disabled:opacity-50"
//               >
//                 {submitting ? "Submit ho rahi hai..." : "Story submit karein"}
//               </button>
//             </div>
//           </form>
//         )}

//         {error && (
//           <div className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700 ring-1 ring-rose-600/20">{error}</div>
//         )}

//         {loading ? (
//           <p className="text-sm text-[#6B6357]">Load ho raha hai...</p>
//         ) : stories.length === 0 ? (
//           <div className="rounded-lg border border-dashed border-[#D8D2C4] bg-white p-10 text-center text-sm text-[#6B6357]">
//             Abhi tak koi story nahi banayi. "+ Nayi Story" par click karein.
//           </div>
//         ) : (
//           <div className="overflow-hidden rounded-lg border border-[#E2DDD1] bg-white">
//             <table className="w-full text-left text-sm">
//               <thead className="bg-[#F6F4EF] text-xs uppercase tracking-wide text-[#6B6357]">
//                 <tr>
//                   <th className="px-4 py-3">Title</th>
//                   <th className="px-4 py-3">Status</th>
//                   <th className="px-4 py-3">Banayi gayi</th>
//                   <th className="px-4 py-3 text-right">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-[#EDE8DC]">
//                 {stories.map((story) => (
//                   <tr key={story._id}>
//                     <td className="px-4 py-3">
//                       <p className="font-medium text-[#1E2430]">{story.title}</p>
//                       {story.status === "rejected" && story.rejectionReason && (
//                         <p className="mt-1 text-xs text-rose-600">Reason: {story.rejectionReason}</p>
//                       )}
//                     </td>
//                     <td className="px-4 py-3">
//                       <StatusBadge status={story.status} />
//                     </td>
//                     <td className="px-4 py-3 text-[#6B6357]">
//                       {new Date(story.createdAt).toLocaleDateString("en-IN")}
//                     </td>
//                     <td className="px-4 py-3 text-right space-x-3">
//                       {story.status === "rejected" && (
//                         <button
//                           onClick={() => handleResubmit(story)}
//                           className="text-xs font-medium text-[#B4501F] hover:underline"
//                         >
//                           Resubmit
//                         </button>
//                       )}
//                       <button
//                         onClick={() => handleDelete(story._id)}
//                         className="text-xs font-medium text-rose-600 hover:underline"
//                       >
//                         Delete
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </main>
//     </div>
//   );
// }


// import React, { useState, useEffect } from "react";
// import {
//   TextField,
//   Button,
//   Box,
//   Typography,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
//   CircularProgress,
//   List,
//   ListItem,
//   ListItemText,
//   Snackbar,
//   Alert,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Chip,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import AddIcon from "@mui/icons-material/Add";
// import ListIcon from "@mui/icons-material/List";
// import DeleteIcon from "@mui/icons-material/Delete";
// import ClearIcon from "@mui/icons-material/Clear";
// import LinkIcon from "@mui/icons-material/Link"; // For general external links
// import CloseIcon from "@mui/icons-material/Close"; // For removing slides
// import YouTubeIcon from '@mui/icons-material/YouTube'; // For YouTube specific icon

// import {
//   createStory,
//   getAllCategories,
//   getAllStories,

//   getStoryById,
//   addSlidesToStory,
//   deleteStory,
  
// } from "../../../services/adminService"; // Adjust the path as per your project structure

// import { getMyStories, createStoryByReporter,updateStoryByReporter,addSlidesToStoryReporter } from "../../../services/reporterService"; // Adjust the path as per your project structure

// // Helper to extract YouTube video ID from various YouTube URLs
// const getYouTubeVideoId = (url) => {
//   if (!url) return null;
//   // Updated regex to include YouTube Shorts pattern '/shorts/'
//   const regExp =
//     /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
//   const match = url.match(regExp);
//   // console.log("getYouTubeVideoId - URL:", url, "Match:", match); // Debug log
//   // Check for the length of the matched ID (YouTube IDs are 11 characters)
//   return (match && match[2] && match[2].length === 11) ? match[2] : null;
// };

// // Helper to get YouTube thumbnail URL
// const getYouTubeThumbnail = (videoId) => {
//   if (!videoId) return null;
//   // Using 'mqdefault' for medium quality thumbnail, 'hqdefault' for high quality
//   return `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
// };

// const CreateStoryForm = () => {
//   const [mode, setMode] = useState("list"); // list | create | edit
//   const [editingStoryId, setEditingStoryId] = useState(null); // Correct variable name

//   const [title, setTitle] = useState("");
//   const [summary, setSummary] = useState("");
//   const [category, setCategory] = useState("");
//   const [tags, setTags] = useState([]);
//   const [currentTagInput, setCurrentTagInput] = useState("");

//   // New state to manage both file uploads and external links
//   const [newSlides, setNewSlides] = useState([]); // [{ type: 'file', file: File, caption: '' }, { type: 'external', url: '', caption: '' }]
//   const [currentExternalUrl, setCurrentExternalUrl] = useState("");
//   const [currentExternalCaption, setCurrentExternalCaption] = useState("");

//   const [existingSlides, setExistingSlides] = useState([]); // When editing, existing slides from the story

//   const [categories, setCategories] = useState([]);
//   const [stories, setStories] = useState([]);

//   const [loading, setLoading] = useState(false); // General loading state for actions
//   const [dataLoading, setDataLoading] = useState(false); // Loading state for fetching data

//   // States for Snackbar feedback
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");

//   // Helper function to show Snackbar messages
//   const showMessage = (msg, severity = "success") => {
//     setSnackbarMessage(msg);
//     setSnackbarSeverity(severity);
//     setSnackbarOpen(true);
//   };

//   // Fetch categories on component mount
//   useEffect(() => {
//     (async () => {
//       try {
//         setDataLoading(true);
//         const res = await getAllCategories();
//         setCategories(res?.data || []);
//       } catch {
//         showMessage("Failed to fetch categories", "error");
//       } finally {
//         setDataLoading(false);
//       }
//     })();
//   }, []);

//   // Fetch stories when mode changes to 'list'
//   const fetchAllStories = async () => {
//     try {
//       setDataLoading(true);
//       const res = await getMyStories();
//       setStories(res?.data || []);
//     } catch (error) { // Added error parameter for better logging
//       console.error("Error fetching stories:", error); // Debug log
//       showMessage("Failed to fetch stories", "error");
//     } finally {
//       setDataLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (mode === "list") fetchAllStories();
//   }, [mode]);

//   // Fetch story details for editing
//   useEffect(() => {
//     if (mode !== "edit" || !editingStoryId) return;
//     (async () => {
//       try {
//         setDataLoading(true);
//         const res = await getStoryById(editingStoryId);
//         const story = res?.data || {};
//         console.log("Fetched Story for editing:", story); // Debug log
//         setTitle(story.title || "");
//         setSummary(story.summary || "");
//         setCategory(story.category?._id || story.category || "");
//         setTags(Array.isArray(story.tags) ? story.tags : []);
//         setExistingSlides(story.slides || []); // Populate existing slides
//         setNewSlides([]); // Clear new slides when loading an existing story
//       } catch (error) {
//         console.error("Error fetching story details:", error); // Debug log
//         showMessage("Failed to fetch story details", "error");
//         setMode("list"); // Fallback to list mode on error
//       } finally {
//         setDataLoading(false);
//       }
//     })();
//   }, [mode, editingStoryId]);

//   // Reset form fields
//   const resetForm = () => {
//     setTitle("");
//     setSummary("");
//     setCategory("");
//     setTags([]);
//     setCurrentTagInput("");
//     setNewSlides([]); // Reset new slides (files + external links)
//     setCurrentExternalUrl("");
//     setCurrentExternalCaption("");
//     setExistingSlides([]); // Reset existing slides
//     setEditingStoryId(null);
//   };

//   // Handle file input change
//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files || []);
//     setNewSlides((prev) => [
//       ...prev,
//       ...files.map((f) => ({ type: "file", file: f, caption: "" })),
//     ]);
//   };

//   // Handle adding an external link
//   const handleAddExternalLink = () => {
//     if (currentExternalUrl.trim()) {
//       setNewSlides((prev) => [
//         ...prev,
//         {
//           type: "external",
//           url: currentExternalUrl.trim(),
//           caption: currentExternalCaption.trim(),
//         },
//       ]);
//       setCurrentExternalUrl("");
//       setCurrentExternalCaption("");
//     } else {
//       showMessage("External URL cannot be empty.", "warning");
//     }
//   };

//   // Handle caption change for a specific slide (newly added)
//   const handleNewSlideCaptionChange = (index, value) => {
//     setNewSlides((prev) => {
//       const copy = [...prev];
//       copy[index].caption = value;
//       return copy;
//     });
//   };

//   // Handle removing a newly added slide
//   const handleRemoveNewSlide = (index) => {
//     setNewSlides((prev) => prev.filter((_, i) => i !== index));
//   };

//   // Handle adding tags
//   const handleAddTag = (e) => {
//     if (e.key === "Enter" && currentTagInput.trim()) {
//       e.preventDefault();
//       if (!tags.includes(currentTagInput.trim()))
//         setTags((prev) => [...prev, currentTagInput.trim()]);
//       setCurrentTagInput("");
//     }
//   };

//   // Handle deleting tags
//   const handleDeleteTag = (tag) => {
//     setTags((prev) => prev.filter((t) => t !== tag));
//   };

//   // Handle form submission (Create or Add Slides)
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const fd = new FormData();
//       const fileSlides = newSlides.filter(s => s.type === 'file');
//       const externalSlidesData = newSlides.filter(s => s.type === 'external').map(s => ({
//         mediaUrl: s.url,
//         caption: s.caption,
//       }));

//       // Append general story data only for create mode
//       if (mode === "create") {
//         if (!title || !category) {
//           showMessage("Title and Category are required to create a story.", "warning");
//           setLoading(false);
//           return;
//         }
//         fd.append("title", title);
//         fd.append("summary", summary);
//         fd.append("category", category);
//         fd.append("tags", JSON.stringify(tags));
//       }

//       // Append file slides and their captions
//       fileSlides.forEach((s, idx) => {
//         fd.append("slides", s.file); // 'slides' is the field for file uploads on backend
//         fd.append(`captions[${idx}]`, s.caption || ""); // Captions array for files
//       });

//       // Append external slides as a JSON string
//       if (externalSlidesData.length > 0) {
//         fd.append("externalSlides", JSON.stringify(externalSlidesData));
//       }


//       if (mode === "create") {
//         await createStoryByReporter(fd);
//         showMessage("Story created successfully!");
//       }

//       if (mode === "edit") {
//         // In edit mode, we only add new slides (files or external links).
//         if (fileSlides.length === 0 && externalSlidesData.length === 0) {
//           showMessage("No new slides (files or external links) selected to add", "warning");
//           setLoading(false);
//           return;
//         }
//         await addSlidesToStoryReporter(editingStoryId, fd); // CORRECTED: Changed editingVideoId to editingStoryId
//         showMessage("Slides added successfully!");
//       }

//       resetForm();
//       setMode("list");
//       fetchAllStories();
//     } catch (error) {
//       console.error("Submission error:", error); // Debug log
//       showMessage(`Failed to ${mode === "create" ? "create" : "update"} story`, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle deleting a story
//   const handleDeleteStory = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this story?")) return;
//     setLoading(true);
//     try {
//       await deleteStory(id);
//       showMessage("Story deleted successfully!");
//       fetchAllStories();
//     } catch (error) {
//       console.error("Error deleting story:", error); // Debug log
//       showMessage("Failed to delete story.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ maxWidth: 1000, mx: "auto" }}>
//       <Typography variant="h6" align="center" sx={{ mb: 4 }}>
//         Story Management
//       </Typography>

//       {/* Mode Switch Buttons */}
//       <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4, flexWrap: "wrap" }}>
//         <Button
//           variant={mode === "list" ? "contained" : "outlined"}
//           startIcon={<ListIcon />}
//           onClick={() => {
//             setMode("list");
//             resetForm();
//           }}
//         >
//           View Stories
//         </Button>
//         <Button
//           variant={mode === "create" ? "contained" : "outlined"}
//           startIcon={<AddIcon />}
//           onClick={() => {
//             setMode("create");
//             resetForm();
//           }}
//         >
//           Create Story
//         </Button>
//       </Box>

//       {dataLoading && (
//         <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
//           <CircularProgress />
//           <Typography sx={{ ml: 2 }}>Loading...</Typography>
//         </Box>
//       )}

//       {/* LIST MODE (Table) */}
//       {mode === "list" && !dataLoading && (
//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>#</TableCell>
//                 <TableCell>Slide</TableCell> {/* Column for media */}
//                 <TableCell>Title</TableCell>
//                 <TableCell>Summary</TableCell>
//                 <TableCell>Status</TableCell>
//                 <TableCell>Category</TableCell>
//                 <TableCell>Tags</TableCell>
//                 <TableCell align="right">Actions</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {stories.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={7} align="center">No stories found. Create one above!</TableCell>
//                 </TableRow>
//               ) : (
//                 stories.map((story, idx) => {
//                   const firstSlide = story.slides && story.slides.length > 0 ? story.slides[0] : null;
//                   // Check for both isExternalLink and mediaUrl presence before calling getYouTubeVideoId
//                   const youTubeVideoId = firstSlide?.isExternalLink && firstSlide?.mediaUrl ? getYouTubeVideoId(firstSlide.mediaUrl) : null;
//                   const youTubeThumbnailUrl = youTubeVideoId ? getYouTubeThumbnail(youTubeVideoId) : null;

//                   console.log(`Story ${idx} - First Slide:`, firstSlide); // Debug log
//                   console.log(`Story ${idx} - YouTube ID:`, youTubeVideoId); // Debug log
//                   console.log(`Story ${idx} - YouTube Thumbnail URL:`, youTubeThumbnailUrl); // Debug log

//                   return (
//                     <TableRow key={story._id} hover>
//                       <TableCell> {idx + 1}</TableCell>
//                       <TableCell>
//                         {firstSlide ? (
//                           firstSlide.isExternalLink && youTubeThumbnailUrl ? (
//                             <img
//                               src={youTubeThumbnailUrl}
//                               alt={`YouTube thumbnail for ${story.title}`}
//                               style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4 }}
//                             />
//                           ) : firstSlide.isExternalLink ? ( // Fallback for other external links or if YouTube ID not found
//                             <LinkIcon color="action" fontSize="large" sx={{ width: 100, height: 60 }} />
//                           ) : firstSlide.mediaType === "image" ? (
//                             <img
//                               src={firstSlide.mediaUrl}
//                               alt={`Slide 1 of ${story.title}`}
//                               style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4 }}
//                             />
//                           ) : ( // Assuming it's a video if not image and not external link
//                             <video
//                               src={firstSlide.mediaUrl}
//                               style={{ width: 100, height: 60, borderRadius: 8 }}
//                               autoPlay
//                               muted
//                               loop
//                               playsInline
//                             />
//                           )
//                         ) : (
//                           "No media"
//                         )}
//                       </TableCell>
//                       <TableCell>{story.title}</TableCell>
//                       <TableCell
//                         sx={{
//                           maxWidth: 250,
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         {story.summary}
//                       </TableCell>
//                       <TableCell>
//                         <Typography
//                           variant="body2"
//                           color={story.status === "published" ? "success" : story.status === "draft" ? "warning" : "error"}
//                         >
//                           {story.status}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>{story.category?.name || "N/A"}</TableCell>
//                       <TableCell>{Array.isArray(story.tags) ? story.tags.join(", ") : ""}</TableCell>
//                       <TableCell align="right">
//                         <IconButton
//                           color="primary"
//                           onClick={() => {
//                             setEditingStoryId(story._id);
//                             setMode("edit");
//                           }}
//                         >
//                           <EditIcon />
//                         </IconButton>
//                         {/* <IconButton
//                           color="error"
//                           onClick={() => handleDeleteStory(story._id)}
//                           disabled={loading}
//                         >
//                           <DeleteIcon />
//                         </IconButton> */}
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       )}


//       {/* CREATE / EDIT FORM */}
//       {(mode === "create" || mode === "edit") && !dataLoading && (
//         <Box
//           component="form"
//           onSubmit={handleSubmit}
//           sx={{ mt: 3, p: 3, boxShadow: 3, borderRadius: 2 }}
//         >
//           <Typography variant="h5" align="center" sx={{ mb: 3 }}>
//             {mode === "create" ? "Create Story" : "Add Slides to Story"}
//           </Typography>

//           {mode === "create" && (
//             <>
//               <TextField
//                 label="Title"
//                 fullWidth
//                 value={title}
//                 onChange={(e) => setTitle(e.target.value)}
//                 sx={{ mb: 2 }}
//                 required
//               />
//               <TextField
//                 label="Summary"
//                 fullWidth
//                 multiline
//                 rows={3}
//                 value={summary}
//                 onChange={(e) => setSummary(e.target.value)}
//                 sx={{ mb: 2 }}
//               />
//               <FormControl fullWidth sx={{ mb: 2 }} required>
//                 <InputLabel>Category</InputLabel>
//                 <Select value={category} onChange={(e) => setCategory(e.target.value)}>
//                   {categories.length ? (
//                     categories.map((cat) => (
//                       <MenuItem key={cat._id} value={cat._id}>
//                         {cat.name}
//                       </MenuItem>
//                     ))
//                   ) : (
//                     <MenuItem disabled>No categories found</MenuItem>
//                   )}
//                 </Select>
//               </FormControl>

//               {/* Tag Input */}
//               <TextField
//                 label="Add Tags (press Enter)"
//                 fullWidth
//                 value={currentTagInput}
//                 onChange={(e) => setCurrentTagInput(e.target.value)}
//                 onKeyDown={handleAddTag}
//                 sx={{ mb: 2 }}
//               />
//               <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
//                 {tags.map((tag) => (
//                   <Chip
//                     key={tag}
//                     label={tag}
//                     onDelete={() => handleDeleteTag(tag)}
//                     deleteIcon={<ClearIcon />}
//                     color="primary"
//                     variant="outlined"
//                   />
//                 ))}
//               </Box>
//             </>
//           )}

//           {/* Existing slides when editing */}
//           {mode === "edit" && existingSlides.length > 0 && (
//             <Box sx={{ mb: 4, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
//               <Typography variant="h6" sx={{ mb: 2 }}>
//                 Existing Slides
//               </Typography>
//               <List dense>
//                 {existingSlides.map((sl, idx) => {
//                   const youTubeVideoId = sl.isExternalLink && sl.mediaUrl ? getYouTubeVideoId(sl.mediaUrl) : null;
//                   console.log(`Existing Slide ${idx} - Media URL: ${sl.mediaUrl}, isExternalLink: ${sl.isExternalLink}, MediaType: ${sl.mediaType}, YouTube ID: ${youTubeVideoId}`); // Debug log

//                   return (
//                     <ListItem
//                       key={sl._id || idx}
//                       sx={{ flexDirection: "column", alignItems: "flex-start", mb: 2, borderBottom: '1px dotted #eee', pb: 2 }}
//                     >
//                       <ListItemText primary={`Slide ${idx + 1}`} />
//                       {/* Display media */}
//                       {sl.isExternalLink ? (
//                         <Box sx={{ mt: 1 }}>
//                           <Typography variant="body2" color="text.primary">
//                             External Link: <a href={sl.mediaUrl} target="_blank" rel="noopener noreferrer">{sl.mediaUrl}</a>
//                           </Typography>
//                           {/* Directly embed YouTube iframe if it's a YouTube link */}
//                           {youTubeVideoId ? (
//                             <Box sx={{ width: '100%', maxWidth: 320, paddingTop: '56.25%', position: 'relative', mt: 1 }}> {/* 16:9 aspect ratio */}
//                               <iframe
//                                 width="100%"
//                                 height="100%"
//                                 src={`https://www.youtube.com/embed/${youTubeVideoId}`}
//                                 frameBorder="0"
//                                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//                                 allowFullScreen
//                                 title="YouTube video player"
//                                 style={{ position: 'absolute', top: 0, left: 0, borderRadius: 4 }}
//                               ></iframe>
//                             </Box>
//                           ) : (
//                             // Fallback for non-YouTube external links or if ID extraction fails
//                             <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                               <LinkIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} /> No direct embed preview available for this external link.
//                             </Typography>
//                           )}
//                         </Box>
//                       ) : sl.mediaType === "image" ? (
//                         <img
//                           src={sl.mediaUrl}
//                           alt={`Slide ${idx + 1}`}
//                           style={{ width: 320, height: 180, objectFit: "cover", borderRadius: 4, mt: 1 }}
//                         />
//                       ) : sl.mediaType === "video" ? (
//                         <video
//                           src={sl.mediaUrl}
//                           style={{ width: 320, height: 180, borderRadius: 8, mt: 1 }}
//                           controls
//                           muted
//                           loop
//                           playsInline
//                         />
//                       ) : (
//                         <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                           Media not supported or unknown type.
//                         </Typography>
//                       )}

//                       {/* Caption */}
//                       {sl.caption && (
//                         <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                           Caption: {sl.caption}
//                         </Typography>
//                       )}
//                     </ListItem>
//                   );
//                 })}
//               </List>
//             </Box>
//           )}

//           {/* New Slides Section */}
//           <Typography variant="h6" sx={{ mb: 2 }}>
//             {mode === "create" ? "Add Slides" : "Add New Slides"}
//           </Typography>

//           {/* File Upload */}
//           <Button variant="contained" component="label" sx={{ mb: 2 }} startIcon={<AddIcon />}>
//             Upload Files (Images/Videos)
//             <input
//               type="file"
//               hidden
//               multiple
//               accept="image/*,video/*"
//               onChange={handleFileChange}
//             />
//           </Button>

//           {/* External Link Input
//           <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1, mb: 2, flexWrap: "wrap" }}>
//             <TextField
//               label="External Media URL (e.g., YouTube Link)"
//               fullWidth={false}
//               sx={{ flexGrow: 1, mr: 1 }}
//               value={currentExternalUrl}
//               onChange={(e) => setCurrentExternalUrl(e.target.value)}
//             />
//             <TextField
//               label="Caption for External Link"
//               fullWidth={false}
//               sx={{ flexGrow: 1, mr: 1 }}
//               value={currentExternalCaption}
//               onChange={(e) => setCurrentExternalCaption(e.target.value)}
//             />
//             <Button
//               variant="outlined"
//               onClick={handleAddExternalLink}
//               startIcon={<LinkIcon />}
//             >
//               Add Link
//             </Button>
//           </Box> */}


//           {/* New slides list (uploaded files + external links) */}
//           {newSlides.length > 0 && (
//             <Box sx={{ mb: 3, p: 2, border: '1px dashed #ccc', borderRadius: 2 }}>
//               <Typography variant="subtitle1" sx={{ mb: 1 }}>Slides to be added:</Typography>
//               <List dense>
//                 {newSlides.map((s, idx) => {
//                   const youTubeVideoId = s.type === 'external' && s.url ? getYouTubeVideoId(s.url) : null;
//                   const youTubeThumbnailUrl = youTubeVideoId ? getYouTubeThumbnail(youTubeVideoId) : null;

//                   console.log(`New Slide ${idx} - Type: ${s.type}, URL: ${s.url || s.file?.name}, YouTube ID: ${youTubeVideoId}`); // Debug log

//                   return (
//                     <ListItem
//                       key={idx}
//                       secondaryAction={
//                         <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveNewSlide(idx)}>
//                           <CloseIcon />
//                         </IconButton>
//                       }
//                       sx={{ flexDirection: "column", alignItems: "stretch", mb: 1, borderBottom: '1px dotted #eee', pb: 1 }}
//                     >
//                       <ListItemText
//                         primary={
//                           s.type === 'file' ?
//                             `File: ${s.file.name}` :
//                             `External Link: ${s.url}`
//                         }
//                       />
//                       {/* Preview for newly added file slides */}
//                       {s.type === 'file' && s.file.type.startsWith('image') && (
//                         <img src={URL.createObjectURL(s.file)} alt="preview" style={{ width: 100, height: 60, objectFit: 'cover', marginTop: 8 }} />
//                       )}
//                       {s.type === 'file' && s.file.type.startsWith('video') && (
//                         <video src={URL.createObjectURL(s.file)} controls style={{ width: 100, height: 60, marginTop: 8 }} />
//                       )}
//                       {/* Preview for newly added external slides (thumbnail if YouTube, else URL text) */}
//                       {s.type === 'external' && youTubeThumbnailUrl ? (
//                         <img
//                           src={youTubeThumbnailUrl}
//                           alt={`YouTube thumbnail for slide ${idx + 1}`}
//                           style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4, mt: 1 }}
//                         />
//                       ) : s.type === 'external' && (
//                         <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                           <LinkIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} /> URL: {s.url}
//                         </Typography>
//                       )}
//                       <TextField
//                         label="Slide Caption / Summary"
//                         fullWidth
//                         value={s.caption}
//                         onChange={(e) => handleNewSlideCaptionChange(idx, e.target.value)}
//                         sx={{ mt: 1 }}
//                         placeholder="Enter caption/summary"
//                       />
//                     </ListItem>
//                   );
//                 })}
//               </List>
//             </Box>
//           )}

//           <Button
//             type="submit"
//             variant="contained"
//             fullWidth
//             disabled={loading || (mode === "edit" && newSlides.length === 0)} // Disable submit if no new slides in edit mode
//             startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
//           >
//             {loading ? (mode === "create" ? "Creating..." : "Adding...") : mode === "create" ? "Create Story" : "Add Slides"}
//           </Button>

//           <Button
//             variant="outlined"
//             fullWidth
//             sx={{ mt: 2 }}
//             disabled={loading}
//             onClick={() => {
//               setMode("list");
//               resetForm();
//             }}
//           >
//             Back to Stories List
//           </Button>
//         </Box>
//       )}

//       {/* Snackbar for user feedback */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={5000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default CreateStoryForm;


import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Snackbar,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import ListIcon from "@mui/icons-material/List";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import LinkIcon from "@mui/icons-material/Link"; // For general external links
import CloseIcon from "@mui/icons-material/Close"; // For removing slides
import YouTubeIcon from '@mui/icons-material/YouTube'; // For YouTube specific icon

import {
  createStory,
  getAllCategories,
  getAllStories,

  getStoryById,
  addSlidesToStory,
  deleteStory,
  
} from "../../../services/adminService"; // Adjust the path as per your project structure

import { getMyStories, createStoryByReporter,updateStoryByReporter,addSlidesToStoryReporter } from "../../../services/reporterService"; // Adjust the path as per your project structure

// Helper to extract YouTube video ID from various YouTube URLs
const getYouTubeVideoId = (url) => {
  if (!url) return null;
  // Updated regex to include YouTube Shorts pattern '/shorts/'
  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url.match(regExp);
  // console.log("getYouTubeVideoId - URL:", url, "Match:", match); // Debug log
  // Check for the length of the matched ID (YouTube IDs are 11 characters)
  return (match && match[2] && match[2].length === 11) ? match[2] : null;
};

// Helper to get YouTube thumbnail URL
const getYouTubeThumbnail = (videoId) => {
  if (!videoId) return null;
  // Using 'mqdefault' for medium quality thumbnail, 'hqdefault' for high quality
  return `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
};

const CreateStoryForm = () => {
  const [mode, setMode] = useState("list"); // list | create | edit
  const [editingStoryId, setEditingStoryId] = useState(null); // Correct variable name

  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [category, setCategory] = useState("");
  const [tags, setTags] = useState([]);
  const [currentTagInput, setCurrentTagInput] = useState("");

  // New state to manage both file uploads and external links
  const [newSlides, setNewSlides] = useState([]); // [{ type: 'file', file: File, caption: '' }, { type: 'external', url: '', caption: '' }]
  const [currentExternalUrl, setCurrentExternalUrl] = useState("");
  const [currentExternalCaption, setCurrentExternalCaption] = useState("");

  const [existingSlides, setExistingSlides] = useState([]); // When editing, existing slides from the story

  const [categories, setCategories] = useState([]);
  const [stories, setStories] = useState([]);

  const [loading, setLoading] = useState(false); // General loading state for actions
  const [dataLoading, setDataLoading] = useState(false); // Loading state for fetching data

  // States for Snackbar feedback
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Helper function to show Snackbar messages
  const showMessage = (msg, severity = "success") => {
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // Fetch categories on component mount
  useEffect(() => {
    (async () => {
      try {
        setDataLoading(true);
        const res = await getAllCategories();
        setCategories(res?.data || []);
      } catch {
        showMessage("Failed to fetch categories", "error");
      } finally {
        setDataLoading(false);
      }
    })();
  }, []);

  // Fetch stories when mode changes to 'list'
  const fetchAllStories = async () => {
    try {
      setDataLoading(true);
      const res = await getMyStories();
      setStories(res?.data || []);
    } catch (error) { // Added error parameter for better logging
      console.error("Error fetching stories:", error); // Debug log
      showMessage("Failed to fetch stories", "error");
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "list") fetchAllStories();
  }, [mode]);

  // Fetch story details for editing
  useEffect(() => {
    if (mode !== "edit" || !editingStoryId) return;
    (async () => {
      try {
        setDataLoading(true);
        const res = await getStoryById(editingStoryId);
        const story = res?.data || {};
        console.log("Fetched Story for editing:", story); // Debug log
        setTitle(story.title || "");
        setSummary(story.summary || "");
        setCategory(story.category?._id || story.category || "");
        setTags(Array.isArray(story.tags) ? story.tags : []);
        setExistingSlides(story.slides || []); // Populate existing slides
        setNewSlides([]); // Clear new slides when loading an existing story
      } catch (error) {
        console.error("Error fetching story details:", error); // Debug log
        showMessage("Failed to fetch story details", "error");
        setMode("list"); // Fallback to list mode on error
      } finally {
        setDataLoading(false);
      }
    })();
  }, [mode, editingStoryId]);

  // Reset form fields
  const resetForm = () => {
    setTitle("");
    setSummary("");
    setCategory("");
    setTags([]);
    setCurrentTagInput("");
    setNewSlides([]); // Reset new slides (files + external links)
    setCurrentExternalUrl("");
    setCurrentExternalCaption("");
    setExistingSlides([]); // Reset existing slides
    setEditingStoryId(null);
  };

  // Handle file input change
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    setNewSlides((prev) => [
      ...prev,
      ...files.map((f) => ({ type: "file", file: f, caption: "" })),
    ]);
  };

  // Handle adding an external link
  const handleAddExternalLink = () => {
    if (currentExternalUrl.trim()) {
      setNewSlides((prev) => [
        ...prev,
        {
          type: "external",
          url: currentExternalUrl.trim(),
          caption: currentExternalCaption.trim(),
        },
      ]);
      setCurrentExternalUrl("");
      setCurrentExternalCaption("");
    } else {
      showMessage("External URL cannot be empty.", "warning");
    }
  };

  // Handle caption change for a specific slide (newly added)
  const handleNewSlideCaptionChange = (index, value) => {
    setNewSlides((prev) => {
      const copy = [...prev];
      copy[index].caption = value;
      return copy;
    });
  };

  // Handle removing a newly added slide
  const handleRemoveNewSlide = (index) => {
    setNewSlides((prev) => prev.filter((_, i) => i !== index));
  };

  // Handle adding tags
  const handleAddTag = (e) => {
    if (e.key === "Enter" && currentTagInput.trim()) {
      e.preventDefault();
      if (!tags.includes(currentTagInput.trim()))
        setTags((prev) => [...prev, currentTagInput.trim()]);
      setCurrentTagInput("");
    }
  };

  // Handle deleting tags
  const handleDeleteTag = (tag) => {
    setTags((prev) => prev.filter((t) => t !== tag));
  };

  // Handle form submission (Create or Add Slides)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const fd = new FormData();
      const fileSlides = newSlides.filter(s => s.type === 'file');
      const externalSlidesData = newSlides.filter(s => s.type === 'external').map(s => ({
        mediaUrl: s.url,
        caption: s.caption,
      }));

      // Append general story data only for create mode
      if (mode === "create") {
        if (!title || !category) {
          showMessage("Title and Category are required to create a story.", "warning");
          setLoading(false);
          return;
        }
        fd.append("title", title);
        fd.append("summary", summary);
        fd.append("category", category);
        fd.append("tags", JSON.stringify(tags));
      }

      // Append file slides and their captions
      fileSlides.forEach((s, idx) => {
        fd.append("slides", s.file); // 'slides' is the field for file uploads on backend
        fd.append(`captions[${idx}]`, s.caption || ""); // Captions array for files
      });

      // Append external slides as a JSON string
      if (externalSlidesData.length > 0) {
        fd.append("externalSlides", JSON.stringify(externalSlidesData));
      }


      if (mode === "create") {
        await createStoryByReporter(fd);
        showMessage("Story created successfully!");
      }

      if (mode === "edit") {
        // In edit mode, we only add new slides (files or external links).
        if (fileSlides.length === 0 && externalSlidesData.length === 0) {
          showMessage("No new slides (files or external links) selected to add", "warning");
          setLoading(false);
          return;
        }
        await addSlidesToStoryReporter(editingStoryId, fd); // CORRECTED: Changed editingVideoId to editingStoryId
        showMessage("Slides added successfully!");
      }

      resetForm();
      setMode("list");
      fetchAllStories();
    } catch (error) {
      console.error("Submission error:", error); // Debug log
      showMessage(`Failed to ${mode === "create" ? "create" : "update"} story`, "error");
    } finally {
      setLoading(false);
    }
  };

  // Handle deleting a story
  const handleDeleteStory = async (id) => {
    if (!window.confirm("Are you sure you want to delete this story?")) return;
    setLoading(true);
    try {
      await deleteStory(id);
      showMessage("Story deleted successfully!");
      fetchAllStories();
    } catch (error) {
      console.error("Error deleting story:", error); // Debug log
      showMessage("Failed to delete story.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 1000, mx: "auto" }}>
      <Typography variant="h6" align="center" sx={{ mb: 4 }}>
        Story Management
      </Typography>

      {/* Mode Switch Buttons */}
      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4, flexWrap: "wrap" }}>
        <Button
          variant={mode === "list" ? "contained" : "outlined"}
          startIcon={<ListIcon />}
          onClick={() => {
            setMode("list");
            resetForm();
          }}
        >
          View Stories
        </Button>
        <Button
          variant={mode === "create" ? "contained" : "outlined"}
          startIcon={<AddIcon />}
          onClick={() => {
            setMode("create");
            resetForm();
          }}
        >
          Create Story
        </Button>
      </Box>

      {dataLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Loading...</Typography>
        </Box>
      )}

      {/* LIST MODE (Table) */}
      {mode === "list" && !dataLoading && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Slide</TableCell> {/* Column for media */}
                <TableCell>Title</TableCell>
                <TableCell>Summary</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Tags</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {stories.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">No stories found. Create one above!</TableCell>
                </TableRow>
              ) : (
                stories.map((story, idx) => {
                  const firstSlide = story.slides && story.slides.length > 0 ? story.slides[0] : null;
                  // Check for both isExternalLink and mediaUrl presence before calling getYouTubeVideoId
                  const youTubeVideoId = firstSlide?.isExternalLink && firstSlide?.mediaUrl ? getYouTubeVideoId(firstSlide.mediaUrl) : null;
                  const youTubeThumbnailUrl = youTubeVideoId ? getYouTubeThumbnail(youTubeVideoId) : null;

                  console.log(`Story ${idx} - First Slide:`, firstSlide); // Debug log
                  console.log(`Story ${idx} - YouTube ID:`, youTubeVideoId); // Debug log
                  console.log(`Story ${idx} - YouTube Thumbnail URL:`, youTubeThumbnailUrl); // Debug log

                  return (
                    <TableRow key={story._id} hover>
                      <TableCell> {idx + 1}</TableCell>
                      <TableCell>
                        {firstSlide ? (
                          firstSlide.isExternalLink && youTubeThumbnailUrl ? (
                            <img
                              src={youTubeThumbnailUrl}
                              alt={`YouTube thumbnail for ${story.title}`}
                              style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4 }}
                            />
                          ) : firstSlide.isExternalLink ? ( // Fallback for other external links or if YouTube ID not found
                            <LinkIcon color="action" fontSize="large" sx={{ width: 100, height: 60 }} />
                          ) : firstSlide.mediaType === "image" ? (
                            <img
                              src={firstSlide.mediaUrl}
                              alt={`Slide 1 of ${story.title}`}
                              style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4 }}
                            />
                          ) : ( // Assuming it's a video if not image and not external link
                            <video
                              src={firstSlide.mediaUrl}
                              style={{ width: 100, height: 60, borderRadius: 8 }}
                              autoPlay
                              muted
                              loop
                              playsInline
                            />
                          )
                        ) : (
                          "No media"
                        )}
                      </TableCell>
                      <TableCell>{story.title}</TableCell>
                      <TableCell
                        sx={{
                          maxWidth: 250,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {story.summary}
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body2"
                          color={story.status === "published" ? "success" : story.status === "draft" ? "warning" : "error"}
                        >
                          {story.status}
                        </Typography>
                      </TableCell>
                      <TableCell>{story.category?.name || "N/A"}</TableCell>
                      <TableCell>{Array.isArray(story.tags) ? story.tags.join(", ") : ""}</TableCell>
                      <TableCell align="right">
                        <IconButton
                          color="primary"
                          onClick={() => {
                            setEditingStoryId(story._id);
                            setMode("edit");
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        {/* <IconButton
                          color="error"
                          onClick={() => handleDeleteStory(story._id)}
                          disabled={loading}
                        >
                          <DeleteIcon />
                        </IconButton> */}
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}


      {/* CREATE / EDIT FORM */}
      {(mode === "create" || mode === "edit") && !dataLoading && (
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ mt: 3, p: 3, boxShadow: 3, borderRadius: 2 }}
        >
          <Typography variant="h5" align="center" sx={{ mb: 3 }}>
            {mode === "create" ? "Create Story" : "Add Slides to Story"}
          </Typography>

          {mode === "create" && (
            <>
              <TextField
                label="Title"
                fullWidth
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                sx={{ mb: 2 }}
                required
              />
              <TextField
                label="Summary"
                fullWidth
                multiline
                rows={3}
                value={summary}
                onChange={(e) => setSummary(e.target.value)}
                sx={{ mb: 2 }}
              />
              <FormControl fullWidth sx={{ mb: 2 }} required>
                <InputLabel>Category</InputLabel>
                <Select value={category} onChange={(e) => setCategory(e.target.value)}>
                  {categories.length ? (
                    categories.map((cat) => (
                      <MenuItem key={cat._id} value={cat._id}>
                        {cat.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No categories found</MenuItem>
                  )}
                </Select>
              </FormControl>

              {/* Tag Input */}
              <TextField
                label="Add Tags (press Enter)"
                fullWidth
                value={currentTagInput}
                onChange={(e) => setCurrentTagInput(e.target.value)}
                onKeyDown={handleAddTag}
                sx={{ mb: 2 }}
              />
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                {tags.map((tag) => (
                  <Chip
                    key={tag}
                    label={tag}
                    onDelete={() => handleDeleteTag(tag)}
                    deleteIcon={<ClearIcon />}
                    color="primary"
                    variant="outlined"
                  />
                ))}
              </Box>
            </>
          )}

          {/* Existing slides when editing */}
          {mode === "edit" && existingSlides.length > 0 && (
            <Box sx={{ mb: 4, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Existing Slides
              </Typography>
              <List dense>
                {existingSlides.map((sl, idx) => {
                  const youTubeVideoId = sl.isExternalLink && sl.mediaUrl ? getYouTubeVideoId(sl.mediaUrl) : null;
                  console.log(`Existing Slide ${idx} - Media URL: ${sl.mediaUrl}, isExternalLink: ${sl.isExternalLink}, MediaType: ${sl.mediaType}, YouTube ID: ${youTubeVideoId}`); // Debug log

                  return (
                    <ListItem
                      key={sl._id || idx}
                      sx={{ flexDirection: "column", alignItems: "flex-start", mb: 2, borderBottom: '1px dotted #eee', pb: 2 }}
                    >
                      <ListItemText primary={`Slide ${idx + 1}`} />
                      {/* Display media */}
                      {sl.isExternalLink ? (
                        <Box sx={{ mt: 1 }}>
                          <Typography variant="body2" color="text.primary">
                            External Link: <a href={sl.mediaUrl} target="_blank" rel="noopener noreferrer">{sl.mediaUrl}</a>
                          </Typography>
                          {/* Directly embed YouTube iframe if it's a YouTube link */}
                          {youTubeVideoId ? (
                            <Box sx={{ width: '100%', maxWidth: 320, paddingTop: '56.25%', position: 'relative', mt: 1 }}> {/* 16:9 aspect ratio */}
                              <iframe
                                width="100%"
                                height="100%"
                                src={`https://www.youtube.com/embed/${youTubeVideoId}`}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                                title="YouTube video player"
                                style={{ position: 'absolute', top: 0, left: 0, borderRadius: 4 }}
                              ></iframe>
                            </Box>
                          ) : (
                            // Fallback for non-YouTube external links or if ID extraction fails
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                              <LinkIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} /> No direct embed preview available for this external link.
                            </Typography>
                          )}
                        </Box>
                      ) : sl.mediaType === "image" ? (
                        <img
                          src={sl.mediaUrl}
                          alt={`Slide ${idx + 1}`}
                          style={{ width: 320, height: 180, objectFit: "cover", borderRadius: 4, mt: 1 }}
                        />
                      ) : sl.mediaType === "video" ? (
                        <video
                          src={sl.mediaUrl}
                          style={{ width: 320, height: 180, borderRadius: 8, mt: 1 }}
                          controls
                          muted
                          loop
                          playsInline
                        />
                      ) : (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                          Media not supported or unknown type.
                        </Typography>
                      )}

                      {/* Caption */}
                      {sl.caption && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                          Caption: {sl.caption}
                        </Typography>
                      )}
                    </ListItem>
                  );
                })}
              </List>
            </Box>
          )}

          {/* New Slides Section */}
          <Typography variant="h6" sx={{ mb: 2 }}>
            {mode === "create" ? "Add Slides" : "Add New Slides"}
          </Typography>

          {/* File Upload */}
          <Button variant="contained" component="label" sx={{ mb: 2 }} startIcon={<AddIcon />}>
            Upload Files (Images/Videos)
            <input
              type="file"
              hidden
              multiple
              accept="image/*,video/*"
              onChange={handleFileChange}
            />
          </Button>

          {/* External Link Input
          <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1, mb: 2, flexWrap: "wrap" }}>
            <TextField
              label="External Media URL (e.g., YouTube Link)"
              fullWidth={false}
              sx={{ flexGrow: 1, mr: 1 }}
              value={currentExternalUrl}
              onChange={(e) => setCurrentExternalUrl(e.target.value)}
            />
            <TextField
              label="Caption for External Link"
              fullWidth={false}
              sx={{ flexGrow: 1, mr: 1 }}
              value={currentExternalCaption}
              onChange={(e) => setCurrentExternalCaption(e.target.value)}
            />
            <Button
              variant="outlined"
              onClick={handleAddExternalLink}
              startIcon={<LinkIcon />}
            >
              Add Link
            </Button>
          </Box> */}


          {/* New slides list (uploaded files + external links) */}
          {newSlides.length > 0 && (
            <Box sx={{ mb: 3, p: 2, border: '1px dashed #ccc', borderRadius: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Slides to be added:</Typography>
              <List dense>
                {newSlides.map((s, idx) => {
                  const youTubeVideoId = s.type === 'external' && s.url ? getYouTubeVideoId(s.url) : null;
                  const youTubeThumbnailUrl = youTubeVideoId ? getYouTubeThumbnail(youTubeVideoId) : null;

                  console.log(`New Slide ${idx} - Type: ${s.type}, URL: ${s.url || s.file?.name}, YouTube ID: ${youTubeVideoId}`); // Debug log

                  return (
                    <ListItem
                      key={idx}
                      secondaryAction={
                        <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveNewSlide(idx)}>
                          <CloseIcon />
                        </IconButton>
                      }
                      sx={{ flexDirection: "column", alignItems: "stretch", mb: 1, borderBottom: '1px dotted #eee', pb: 1 }}
                    >
                      <ListItemText
                        primary={
                          s.type === 'file' ?
                            `File: ${s.file.name}` :
                            `External Link: ${s.url}`
                        }
                      />
                      {/* Preview for newly added file slides */}
                      {s.type === 'file' && s.file.type.startsWith('image') && (
                        <img src={URL.createObjectURL(s.file)} alt="preview" style={{ width: 100, height: 60, objectFit: 'cover', marginTop: 8 }} />
                      )}
                      {s.type === 'file' && s.file.type.startsWith('video') && (
                        <video src={URL.createObjectURL(s.file)} controls style={{ width: 100, height: 60, marginTop: 8 }} />
                      )}
                      {/* Preview for newly added external slides (thumbnail if YouTube, else URL text) */}
                      {s.type === 'external' && youTubeThumbnailUrl ? (
                        <img
                          src={youTubeThumbnailUrl}
                          alt={`YouTube thumbnail for slide ${idx + 1}`}
                          style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4, mt: 1 }}
                        />
                      ) : s.type === 'external' && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                          <LinkIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} /> URL: {s.url}
                        </Typography>
                      )}
                      <TextField
                        label="Slide Caption / Summary"
                        fullWidth
                        value={s.caption}
                        onChange={(e) => handleNewSlideCaptionChange(idx, e.target.value)}
                        sx={{ mt: 1 }}
                        placeholder="Enter caption/summary"
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Box>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={loading || (mode === "edit" && newSlides.length === 0)} // Disable submit if no new slides in edit mode
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {loading ? (mode === "create" ? "Creating..." : "Adding...") : mode === "create" ? "Create Story" : "Add Slides"}
          </Button>

          <Button
            variant="outlined"
            fullWidth
            sx={{ mt: 2 }}
            disabled={loading}
            onClick={() => {
              setMode("list");
              resetForm();
            }}
          >
            Back to Stories List
          </Button>
        </Box>
      )}

      {/* Snackbar for user feedback */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateStoryForm;